import React from "react";
import ContainerComponent from "../../../../components/Container/ContainerComponent";
import ButtonComponent from "../../../../components/Button/ButtonComponent";
import TypographyComponent from "../../../../components/Typography/ThypographyComponent";
import BoxComponent from "../../../../components/Box/BoxComponent";
import { formatNumberToDinheiro } from "../../../../utils/dinheiro";
import { formatNumberToPercentual } from "../../../../utils/percentual";
import { ReactComponent as CoracaoIcon } from "../../../../assets/icons/coracao.svg";
import { ReactComponent as CarrinhoIcon } from "../../../../assets/icons/carrinho.svg";
import { ItemDestaque } from "../CatalogoPage";
import CarouselComponent from "../../../../components/Carousel/CarouselComponent";
import CardComponent from "../../../../components/Card/CardComponent";
import SvgComponent from "../../../../components/Image/SvgComponent";

interface DestaquesProps {
    itensDestaque: ItemDestaque[];
    onClickCarrinho: (item: ItemDestaque) => void;
    onClickLike: (item: ItemDestaque) => void;
}

const DestaquesComponent = (props: DestaquesProps) => {
    return <ContainerComponent
        component="section"
        sx={{
            mt: 4
        }}
    >
        <TypographyComponent
            variant="h5" fontWeight="bold" mb={2}
            sx={{
                fontFamily: '"Inter", "Roboto", "Helvetica", "Arial", sans-serif',
                fontWeight: 600,       // Semi Bold
                fontSize: '2.5rem',    // 40px / 16px = 2.5rem
                lineHeight: 1,         // 100% 
                letterSpacing: '0em',
                display: 'inline-flex',
                alignItems: 'center',
            }}
        >
            Destaques
        </TypographyComponent>

        {Array.isArray(props.itensDestaque) && props.itensDestaque.length > 0 && (
            <CarouselComponent>
                {props.itensDestaque.map((item: ItemDestaque, index: number) => {
                    const midiaAtiva = item.midias?.find(m => m.ativo);
    
                    return <CardComponent
                        component="div"
                        key={`destaque-${index}`}
                        sx={{
                            display: "flex",
                            flexDirection: "column",
                            width: "370px",
                            height: "436px",
                            opacity: 1,
                            pb: '20px',                // padding-bottom: 20px
                            borderRadius: '14.4px',
                            transform: 'rotate(0deg)',
                            overflow: 'hidden',
                            border: '1px solid #e0e0e0',
                            boxShadow: '0px 2px 4px -2px rgba(0, 0, 0, 0.1), 0px 4px 6px -1px rgba(0, 0, 0, 0.1)',
                        }}
                    >
                        {midiaAtiva && (
                            <BoxComponent
                                component="header"
                                sx={{
                                    display: "flex",
                                    height: 224,
                                    position: "relative",
                                }}
                            >
                                <BoxComponent component="img"
                                    sx={{
                                        width: 474.66,
                                        height: 224,
                                        angle: "0 deg",
                                        opacity: 1
                                    }}
                                    src={midiaAtiva.caminho}
                                    alt={`image-${item.titulo}`}
                                />
        
                                {item.status !== null && item.status !== "" && (
                                    <BoxComponent component="span"
                                        sx={{
                                            height: 24,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            pt: '4px',
                                            pr: '12px',
                                            pb: '4px',
                                            pl: '12px',
                                            borderRadius: '100px',
                                            opacity: 1,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            boxSizing: 'border-box',
                                            position: "absolute",
                                            backgroundColor: item.status === "Novo" ? "#2B7FFF" : "#FB2C36",
                                            color: "#fff",
                                            top: 8,
                                            right: 12,
                                            m: 0
                                        }}
                                    >
                                        <TypographyComponent
                                            variant="body2"
                                            sx={{
                                                fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                                                fontWeight: 700,
                                                fontSize: '0.75rem',   // 12px / 16px = 0.75rem
                                                lineHeight: 0,
                                                letterSpacing: '0.02em',
                                                textTransform: 'inherit',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                margin: 0,
                                                padding: 0
                                            }}
                                        >
                                            {item.status}
                                        </TypographyComponent>
                                    </BoxComponent>
                                )}
        
                                {/* INFORMAÇÕES A ESQUERDA */}
                                {(item.desconto != null && item.desconto !== 0) && (
                                    <BoxComponent component="span"
                                        sx={{
                                            height: 24,
                                            display: 'flex',
                                            alignItems: 'center',
                                            justifyContent: 'center',
                                            pt: '4px',
                                            pr: '12px',
                                            pb: '4px',
                                            pl: '12px',
                                            borderRadius: '100px',
                                            opacity: 1,
                                            border: '1px solid',
                                            borderColor: 'divider',
                                            boxSizing: 'border-box',
                                            position: "absolute",
                                            backgroundColor: "#FB2C36",
                                            color: "#fff",
                                            top: 8,
                                            left: 12,
                                            m: 0
                                        }}
                                    >
                                        <TypographyComponent
                                            variant="body2"
                                            sx={{
                                                fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                                                fontWeight: 700,
                                                fontSize: '0.75rem',   // 12px / 16px = 0.75rem
                                                lineHeight: 0,
                                                letterSpacing: '0.02em',
                                                textTransform: 'uppercase',
                                                display: 'inline-flex',
                                                alignItems: 'center',
                                                margin: 0,
                                                padding: 0
                                            }}
                                        >
                                            {`${formatNumberToPercentual(item.desconto, 0)}`}
                                        </TypographyComponent>
                                    </BoxComponent>
                                )}
        
                                <ButtonComponent
                                    id={`like-item-${item.titulo}`}
                                    type="button"
                                    onClick={() => props.onClickLike(item)}
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        position: "absolute",
                                        bottom: 8,
                                        right: 12,
                                        width: "36px",
                                        height: "36px",
                                        minWidth: "36px",
                                        maxWidth: "36px",
                                        borderRadius: '50% !important',
                                        padding: 0,
                                        backgroundColor: "#FFF",
                                        opacity: 1,
                                        border: 'none',
                                        boxSizing: 'border-box',
                                    }}
                                >
                                    <SvgComponent
                                        icon={<CoracaoIcon />}
                                        sx={{
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            "& svg, & svg *": {
                                                stroke: "#99A1AF"
                                            },
                                            width: 16.7,
                                            height: 15
                                        }}
                                    />
                                </ButtonComponent>
                            </BoxComponent>
                        )}    
    
                        <BoxComponent
                            component="section"
                            sx={{
                                width: "100%",
                                height: 192,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: '4px',
                                padding: '16px',
                                opacity: 1,
                                transform: 'rotate(0deg)',
                                boxSizing: 'border-box',
                            }}
                        >
                            <TypographyComponent variant="h3"
                                sx={{
                                    fontFamily: '"Font 2", "Roboto", "Helvetica", "Arial", sans-serif',
                                    fontWeight: 700,
                                    fontSize: '1.125rem',  // 18px / 16px
                                    lineHeight: 1.555,     // 28px / 18px
                                    letterSpacing: '0em',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                }}>
                                {item.titulo}
                            </TypographyComponent>
                            <TypographyComponent variant="h3"
                                sx={{
                                    fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                                    fontWeight: 400,
                                    fontSize: '0.875rem',  // 14px / 16px
                                    lineHeight: 1.428,     // 20px / 14px
                                    letterSpacing: '0em',
                                    color: '#4B5563',
                                    display: 'inline-flex',
                                    alignItems: 'center',
                                }}>
                                {item.descricao}
                            </TypographyComponent>
    
                            <BoxComponent
                                component="div"
                                sx={{
                                    display: "flex",
                                    gap: 2,
                                    pt: "7.2px",
                                    pb: "11.99px"
                                }}
                            >
                                {item.precoAtual && (
                                    <TypographyComponent variant="h3"
                                        sx={{
                                            fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                                            fontWeight: 700,
                                            fontSize: '1.5rem',    // 24px / 16px = 1.5rem
                                            lineHeight: 1.333,     // 32px / 24px
                                            letterSpacing: '0em',
                                            display: 'inline-flex',
                                            alignItems: 'center',  // Para o vertical-align: middle,
                                            color: "#EF4444"
                                        }}>
                                        {formatNumberToDinheiro(item.precoAtual)}
                                    </TypographyComponent>
                                )}
    
                                {item.precoAnterior && (
                                    <TypographyComponent variant="h3"
                                        sx={{
                                            fontFamily: '"Font 1", "Roboto", "Helvetica", "Arial", sans-serif',
                                            fontWeight: 400,
                                            fontSize: '0.875rem',  // 14px / 16px
                                            lineHeight: 1.428,     // 20px / 14px
                                            letterSpacing: '0em',
                                            textDecoration: 'line-through',
                                            color: '#9CA3AF',      // Sugestão: um cinza claro (gray-400)
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                        }}>
                                        {formatNumberToDinheiro(item.precoAnterior)}
                                    </TypographyComponent>
                                )}
                            </BoxComponent>
    
                            <ButtonComponent
                                id={`add-carrinho-${index}`}
                                onClick={() => props.onClickCarrinho(item)}
                                sx={{
                                    width: "100%",
                                    backgroundColor: "#EF4444",
                                    color: "#FFFFFF",
                                    '&:hover': {
                                        backgroundColor: "#DC2626",
                                    },
                                    borderRadius: '10.4px',
                                    opacity: 1,
                                    boxShadow: 'none',
                                    pt: '12px',
                                    pr: '24px',
                                    pb: '12px',
                                    pl: '24px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    gap: '8px',
                                    textTransform: 'none',
                                    //fontWeight: 600,
                                }}
                            >
                                <SvgComponent
                                    icon={<CarrinhoIcon />}
                                    sx={{
                                        display: "flex",
                                        alignItems: "center",
                                        justifyContent: "center",
                                        "& svg, & svg *": {
                                            stroke: "#FFF"
                                        },
                                        width: 16.7,
                                        height: 15
                                    }}
                                />
                                
                                <TypographyComponent
                                    sx={{
                                        fontFamily: '"Font 7", "Roboto", "Helvetica", "Arial", sans-serif',
                                        fontWeight: 500,
                                        fontSize: '1rem',      // 16px / 16px
                                        lineHeight: 1.5,       // 24px / 16px
                                        letterSpacing: '0em',
                                        textAlign: 'center',
                                        textTransform: 'none',
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                    }}>
                                    Adicionar ao carrinho
                                </TypographyComponent>
                            </ButtonComponent>
                        </BoxComponent>
                    </CardComponent>
                })}
            </CarouselComponent>
        )}

    </ContainerComponent>
}

export default DestaquesComponent;